import { render, staticRenderFns } from "./AppHead.vue?vue&type=template&id=7ff03d21&scoped=true"
import script from "./AppHead.vue?vue&type=script&lang=js"
export * from "./AppHead.vue?vue&type=script&lang=js"
import style0 from "./AppHead.vue?vue&type=style&index=0&id=7ff03d21&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff03d21",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\Ezchicken\\ezchickenapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ff03d21')) {
      api.createRecord('7ff03d21', component.options)
    } else {
      api.reload('7ff03d21', component.options)
    }
    module.hot.accept("./AppHead.vue?vue&type=template&id=7ff03d21&scoped=true", function () {
      api.rerender('7ff03d21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppHead.vue"
export default component.exports